var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('div',{staticStyle:{"position":"fixed","bottom":"100px","right":"18px","z-index":"100"}},[_c('img',{staticClass:"bounce-animation",staticStyle:{"width":"40px","height":"40px"},attrs:{"src":"/media/logo-zalo.png","alt":"logo-zalo"},on:{"click":_vm.openZalo}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }